import { Page, Text, Document, StyleSheet, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  body: {
    paddingTop: 20,
    paddingBottom: 65,
    paddingHorizontal: 20
  },
  arrow: {
    width: '6'
  },
  image: {
    width: '2%',
    marginLeft: '20px',
    alignItems: 'flex-start'
  },
  spacing: {
    width: '97',
    alignItems: 'flex-start',
    alignContent: 'space-between',
    marginTop: '5',
    marginBottom: '5',
    maxLines: 1,
    textOverflow: 'ellipsis'
  },

  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  }
});

const PatientCompliancePdfTableFile = ({ data }: any) => {
  return (
    <Document>
      <Page style={styles.body} orientation="landscape" wrap>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between'
          }}
          fixed
        >
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              alignItems: 'flex-start',
              borderBottomColor: 'black',
              borderBottomWidth: 1,
              marginBottom: 7,
              marginTop: 20,
              fontWeight: 'bold'
            }}
          >
            <Text style={{ fontSize: 12, marginLeft: 0 }}>Unit</Text>
            <Text style={{ fontSize: 12, marginLeft: 112 }}>Unit Type</Text>
            <Text style={{ fontSize: 12, marginLeft: 24 }}>Census</Text>
            <Text style={{ fontSize: 12, marginLeft: 30 }}>Rounded #</Text>
            <Text style={{ fontSize: 12, marginLeft: 25 }}>Rounded %</Text>
            <Text style={{ fontSize: 12, marginLeft: 25 }}>Unable #</Text>
            <Text style={{ fontSize: 12, marginLeft: 25 }}>Unable %</Text>
            <Text style={{ fontSize: 12, marginLeft: 25 }}>Not Rounded #</Text>
            <Text style={{ fontSize: 12, marginLeft: 25 }}>Not Rounded %</Text>
          </View>
          <View
            style={{
              borderBottomColor: 'black',
              borderBottomWidth: 1
            }}
          />
        </View>
        {data.map((s: any) => (
          <View
            key={s.id}
            style={{
              fontSize: 8,
              borderBottomColor: 'black',
              borderBottomWidth: 1
            }}
            wrap={false}
          >
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                marginRight: '20'
              }}
              wrap={false}
            >
              <View style={{ ...styles.spacing, width: 150 }}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>{s.unit}</Text>
                <Text>{s.unitId}</Text>
              </View>
              <View style={{ ...styles.spacing, paddingLeft: 10 }}>
                <Text>{s.unitType}</Text>
              </View>
              <View style={{ ...styles.spacing, marginLeft: 12 }}>
                <Text>{s.census}</Text>
              </View>
              <View style={styles.spacing}>
                <Text>{s.roundedNumber}</Text>
              </View>
              <View style={styles.spacing}>
                <Text>{s.roundedPercent}%</Text>
              </View>
              <View style={{ ...styles.spacing, paddingLeft: 10 }}>
                <Text>{s.unableNumber}</Text>
              </View>
              <View style={styles.spacing}>
                <Text>{s.unablePercent}%</Text>
              </View>
              <View style={{ ...styles.spacing, paddingLeft: 12 }}>
                <Text>{s.notRoundedNumber}</Text>
              </View>
              <View style={{ ...styles.spacing, paddingLeft: 35 }}>
                <Text>{s.notRoundedPercent}%</Text>
              </View>
            </View>
          </View>
        ))}
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default PatientCompliancePdfTableFile;
